import { render, staticRenderFns } from "./redenvelope.vue?vue&type=template&id=6a764044&scoped=true"
import script from "./redenvelope.vue?vue&type=script&lang=js"
export * from "./redenvelope.vue?vue&type=script&lang=js"
import style0 from "./redenvelope.vue?vue&type=style&index=0&id=6a764044&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a764044",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins_home/workspace/tax-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a764044')) {
      api.createRecord('6a764044', component.options)
    } else {
      api.reload('6a764044', component.options)
    }
    module.hot.accept("./redenvelope.vue?vue&type=template&id=6a764044&scoped=true", function () {
      api.rerender('6a764044', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/cps/views/configuration/redenvelope/redenvelope.vue"
export default component.exports